export default "__VITE_ASSET__DWoateJL__"